import React, { useEffect } from "react";
import Popover from "@mui/material/Popover";

import { Flex } from "../container-components";

import { IconButton } from "./buttons";

const P = (props) => {
  const {
    text,
    icon,
    content,
    inheritStyle,
    inlinePadding,
    style,
    anchorOrigin,
    isClick,

    id,
    width,
    height,
    iconStyle,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleContainerClick = (e) => {
    setAnchorEl(null);
  };

  useEffect(() => {
    handleClose();
  }, [isClick]);

  return (
    <div
      style={
        icon
          ? { display: "flex", justifyContent: "flex-end", ...style }
          : { ...style }
      }
    >
      {text ? (
        <span
          style={{ cursor: "pointer" }}
          className={
            !inheritStyle ? "color-primary salusion-3" : "color-primary "
          }
          onClick={handleClick}
        >
          {text}
        </span>
      ) : icon && isClick ? (
        <IconButton
          iconConfig={{ name: icon.name, size: icon.size || "small" }}
          onClick={handleClick}
          id={id || ""}
          color={icon.color || "tertiary"}
        />
      ) : (
        <div
          // onMouseEnter={browserWidth >= 800 && handleClick}
          onMouseLeave={handleClose}
          // onClick={browserWidth < 800 && handleClick}
          style={
            width || height
              ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width,
                height,
              }
              : {
                width: icon?.size !== "very-small" ? "40px" : "25px",
                height: icon?.size !== "very-small" ? "40px" : "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }
          }
        >
          <Flex>
            <i
              // style={{ textAlign: 'right' }}
              aria-owns={open ? "mouse-over-popover" : undefined}
              aria-haspopup="true"
              style={{ cursor: "default" }}
              className={`${icon.provider} ${icon?.size || "small"}`}
            >
              {icon.name}
            </i>
          </Flex>
        </div>
      )}

      <Popover
        id="mouse-over-popover"
        open={open}
        style={{
          pointerEvents: isClick ? "auto" : "none",
          margin: "3px 0 5px 0",
        }}
        anchorEl={anchorEl}
        anchorOrigin={
          anchorOrigin || {
            vertical: "center",
            horizontal: "center",
          }
        }
        onClose={handleClose}
        disableRestoreFocus
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Flex
          id="popover-content"
          style={{ padding: !inlinePadding && "20px 30px" }}
          onClick={handleContainerClick}
        >
          {content}
        </Flex>
      </Popover>
    </div>
  );
};

export default P;
